const topicNav = document.querySelectorAll('[data-behavior="open-topic-nav"]')

if (topicNav.length > 0) {
    topicNav.forEach(topicNav => {
        topicNav.addEventListener('click', event => {
            const target = event.currentTarget;
            target.classList.toggle('open');
        })
    });
}